/**
 * The PalCare wordmark for the active theme.
 *
 * PCLC.svg draws "Pal" in #383838, which is 11.73:1 on white and 1.43:1 on the
 * dark sidebar -- it simply disappears. PCDC.svg is the same artwork with that
 * one fill at #d3d8e0, which is 11.74:1 on #1a1d27: the wordmark keeps the
 * weight it has always had, inverted. "Care" and the wifi gradient stay on the
 * brand blue in both files.
 *
 * IMPORTANT -- do not use this in the V1 / classic components (Header, Navbar,
 * Navigation). This returns the user's stored PREFERENCE, while `useForceLight`
 * pins the DOM to light on the V1 pages a migrated user can still reach without
 * touching that preference. On one of those pages the two disagree, and this
 * hook would hand you the dark logo for a light-rendered page. Those components
 * import PCLC.svg directly and should keep doing so.
 */

import { useTheme } from '../contexts/ThemeContext.jsx';
import logoLight from '../img/PCLC.svg';
import logoDark from '../img/PCDC.svg';

export function useBrandLogo() {
    const { theme } = useTheme();
    return theme === 'dark' ? logoDark : logoLight;
}

export default useBrandLogo;
